import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import toast, { Toaster } from "react-hot-toast";
import trustLogo from "../assets/trust_logo.png";

export default function ForgotPassword() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email");
    try {
      setLoading(true);
      await resetPassword(email);
      setSent(true);
      toast.success("Reset email sent!");
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        toast.error("No account found with this email");
      } else {
        toast.error("Failed to send reset email. Try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.root}>
      <Toaster position="top-center"/>
      <div style={s.card}>
        <div style={s.logoWrap}>
          <img src={trustLogo} alt="HTS" style={s.logo}/>
        </div>
        <h1 style={s.title}>Reset Password</h1>
        <p style={s.sub}>We'll send a reset link to your email</p>

        {sent ? (
          <div style={s.successBox}>
            <div style={{fontSize:32, marginBottom:12}}>📬</div>
            <div style={{color:"#fef3e2", fontWeight:700, marginBottom:8}}>Check your inbox!</div>
            <div style={{color:"#78716c", fontSize:13, lineHeight:1.6}}>
              A password reset link has been sent to <strong style={{color:"#f59e0b"}}>{email}</strong>.
              Check your spam folder if you don't see it.
            </div>
            <Link to="/login" style={{...s.link, display:"inline-block", marginTop:20}}>
              ← Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={s.form}>
            <div style={s.field}>
              <label style={s.label}>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={s.input}
                required
              />
            </div>
            <button type="submit" disabled={loading}
              style={{...s.btn, opacity: loading ? 0.7 : 1}}>
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <div style={{textAlign:"center", marginTop:16}}>
              <Link to="/login" style={s.link}>← Back to Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  root: {
    minHeight:"100vh", background:"#0a0908",
    display:"flex", alignItems:"center", justifyContent:"center",
    padding:20, fontFamily:"'Plus Jakarta Sans', system-ui, sans-serif",
  },
  card: {
    background:"#111009", border:"1px solid rgba(255,255,255,0.08)",
    borderRadius:20, padding:"40px 36px", width:"100%", maxWidth:420, textAlign:"center",
  },
  logoWrap: { marginBottom:20 },
  logo: { width:72, height:72, objectFit:"contain", borderRadius:16 },
  title: { fontSize:24, fontWeight:800, color:"#fef3e2", margin:"0 0 6px", fontFamily:"'Playfair Display', serif" },
  sub: { fontSize:13, color:"#78716c", marginBottom:32 },
  form: { textAlign:"left" },
  field: { marginBottom:20 },
  label: { display:"block", fontSize:12, fontWeight:700, color:"#a8a29e", marginBottom:7, textTransform:"uppercase", letterSpacing:"0.5px" },
  input: { width:"100%", padding:"12px 14px", background:"#1a1714", border:"1px solid rgba(255,255,255,0.1)", borderRadius:10, color:"#fef3e2", fontSize:14, fontFamily:"inherit", outline:"none", boxSizing:"border-box" },
  btn: { width:"100%", padding:14, background:"#f59e0b", color:"#0a0908", border:"none", borderRadius:12, fontSize:15, fontWeight:800, cursor:"pointer", fontFamily:"inherit" },
  link: { fontSize:13, color:"#f59e0b", textDecoration:"none", fontWeight:600 },
  successBox: { background:"#1a1714", border:"1px solid rgba(255,255,255,0.08)", borderRadius:14, padding:24 },
};
